/**
 * 路由规则
 * name: 必填
 * path: 需要全部小写，参数字段也必须小写,path本身 必须2级路径，用以区分模块
 * components: 需要是()=>import 方式
 * meta: 必须
 *    {
 *      headerTitle: 必填，该页面的标题，无论是否自定义头部
 *      isShowHeader: 用来控制是否显示H5/PC头部，默认promotion下isShowHeader=true，appw isShowHeader 不生效
 *      isEnableNavigationBar: appw专用，如果采用自定义头部，则设置isEnableNavigationBar=false，不设置情况下默认是true
 *    }
 */
import houseRouter from './house'
import channelRouter from './channel'
import orderRouter from './order'
import lockRouter from './lock'
import financeRouter from './finance'
import setupRouter from './setup'
import serviceRouter from './service'

let router = [
  {
    path: '/roomState',
    name: 'roomState',
    component: () => import('../views/home/index.vue'),
    meta: {
      headerTitle: '房态',
      hide: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/roomState'),
    meta: {
      headerTitle: '房态',
      auth: 1002
    }
  },
  {
    path: '/roomPrice',
    name: 'roomPrice',
    component: () => import('../views/roomPrice'),
    meta: {
      headerTitle: '房价',
      auth: 1013,
      showBadge: true,
    }
  },
  orderRouter,
  lockRouter,
  financeRouter,
  serviceRouter,
  houseRouter,
  channelRouter,
  {
    path: '/keepAccount',
    name: 'keepAccount',
    component: () => { },
    meta: {
      headerTitle: '记一笔',
    }
  },
  setupRouter
]

export default router
